import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ImprovementrequestService } from 'src/app/core/services/improvement-request-service';
import { LearningAreasString } from 'src/app/model/course-program';
import { ImprovementRequestSearch, TipoStatoProposta } from 'src/app/model/ImprovementRequestSearch';

@Component({
  selector: 'ms-improvement-requests',
  templateUrl: './improvement-requests.component.html',
  styleUrls: ['./improvement-requests.component.scss'],
  animations: [
    trigger('detailExpand', [
        state('collapsed', style({ height: '0px', minHeight: '0' })),
        state('expanded', style({ height: '*' })),
        transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class ImprovementRequestsComponent implements OnInit {

  constructor(
    private _formBuilder: FormBuilder,
    private improvementrequestService: ImprovementrequestService
  ) { }

  search = this._formBuilder.group({
    product: '',
    functionalArea: '',
    init: '',
    end: '',
    status: ''
  });

  improvementRequestSearch: ImprovementRequestSearch = null;
  isLoading: boolean = false;

  ngOnInit(): void {
    this.isLoading = true;
    this.improvementrequestService.getImpReqSearchData()
    .then((res) => {
      if(!res.Result || !res.Content || !res.Content[0]) throw new Error('Error to find products and functional areas')
      this.improvementRequestSearch = res.Content[0];
      this.isLoading = false
    })
    .catch((err) => {
      this.isLoading = false
    })
    this.search.valueChanges.debounceTime(250).subscribe(value => { this.setVisibleRequests(value) })
  }

  getAreaString(areaCode: number): string {
    return TipoStatoProposta[areaCode.toString()]
  }

  getRequestStatuses = () => Object.keys(TipoStatoProposta).filter((v) => isNaN(Number(v)))
  getRequestStatusStringValue = (statusString: string) => Object.keys(TipoStatoProposta).find(key => TipoStatoProposta[key] === statusString) ?? '';

  convert(str) {
    var date = new Date(str),
      mnth = ("0" + (date.getMonth() + 1)).slice(-2),
      day = ("0" + date.getDate()).slice(-2);
    return [date.getFullYear(), mnth, day].join("-");
  }

  searchRequests() {
    this.isLoading = true;
    this.improvementrequestService.getImprovementRequests(
      this.search.value['product'], 
      this.search.value['functionalArea'] ?? '',
      this.convert(this.search.value['init']) ?? '',
      this.convert(this.search.value['end']) ?? '',
      this.search.value['status'] ?? ''
    )
    .then((res) => {
      if(!res.Result || !res.Content || !res.Content[0]) throw new Error('Error to find improvement requests')
      this.isLoading = false
    })
    .catch((err) => {
      this.isLoading = false
    })
  }

  setVisibleRequests(parametes: object){
    /*this.courseProgramsTable.data = this.originalCoursePrograms.filter(cp => {
      return (cp.Description.toLowerCase().trim().includes(parametes['searchString']?.toLowerCase().trim() ?? '') || cp.Program.toLowerCase().trim().includes(parametes['searchString']?.toLowerCase().trim() ?? '') ) &&
      (LearningAreasString[`AREA${cp.LearningArea}`]?.includes(parametes['courseArea'] ?? '') || parametes['courseArea'] == '' ) &&
      (CourseProductCodes[cp.ProductCode]?.includes(parametes['courseProduct'] ?? '') || parametes['courseProduct'] == '' ) &&
      (CourseLanguages[cp.CourseLanguage]?.includes(parametes['courseLanguage'] ?? '') || parametes['courseLanguage'] == '' )
    })*/
  }
}
